import { IProductGroup } from '@cbgms/api'
import useQuery from '@cbgms/base/http/use-query'
import { useDispatch } from 'react-redux'
import { getProductTree } from '../../state/actions'
import { productTreeCacheKey } from './cache-keys'

export const useGetProductTree = (ProductGroupUUID?: string, onSuccess?: (data: IProductGroup) => void) => {
  const dispatch = useDispatch()

  return useQuery(
    productTreeCacheKey(ProductGroupUUID || ''),
    async () => {
      if (ProductGroupUUID) {
        const { Data } = await dispatch(getProductTree(ProductGroupUUID))
        return Data
      }
      return null
    },
    { onSuccess, refetchOnWindowFocus: false }
  )
}
